import React, { useState } from "react";
import { ROOT_URL } from "../../../../config/url";
import axios from "axios";
import { useAction, useList, useUnroll } from "@vokymlak/kabinet-ui";

export const useKanbanSpaces = () => {
  const {
    list: [list, _count, setList],
    update: [isUpdateList, setIsUpdateList, updateList],
  } = useList({ apiUrl: "/api/kanban-spaces", rootUrl: ROOT_URL });

  const { unrolls, isUnroll, changeUnroll, changeAllUnroll } = useUnroll();

  useAction("kanban", () => updateList());

  const onDragEnd = (result) => {
    if (result.destination) {
      const oldIndex = result.source.index;
      const newIndex = result.destination.index;
      const draggableId = result.draggableId;
      const droppableId = result.source.droppableId;

      let object = null;

      if (!!list) {
        if (droppableId === 'droppable') {
          list.map((item) => {
            if (draggableId === item.uuid) {
              object = {...item};
            }
          });

          setList([...dndArray(list, oldIndex, newIndex)]);

          axios
            .get("/api/kanban-space/" + object.uuid + "/index/" + newIndex, {
              withCredentials: false,
              baseURL: ROOT_URL,
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + localStorage.getItem("tokenSession"),
              },
            })
            .then(() => {
              setIsUpdateList(!isUpdateList);
            })
            .catch(() => {
              setIsUpdateList(!isUpdateList);
            });
        } else {

          list.map((item) => {
            if (droppableId === item.uuid && !!item.kanban_states) {
              item.kanban_states.map((state) => {
                if (draggableId === state.uuid) {
                  object = {...state};
                }
              });
              item.kanban_states = [...dndArray(item.kanban_states, oldIndex, newIndex)]
            }
          });

          setList([...list]);

          axios
            .get("/api/kanban-state/" + object.uuid + "/index/" + newIndex, {
              withCredentials: false,
              baseURL: ROOT_URL,
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + localStorage.getItem("tokenSession"),
              },
            })
            .then(() => {
              setIsUpdateList(!isUpdateList);
            })
            .catch(() => {
              setIsUpdateList(!isUpdateList);
            });
        }
      }
    }
  };

  const dndArray = (arr, old_index, new_index) => {
    if (new_index >= arr.length) {
      let k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };

  return {
    list,
    setList,

    unrolls,
    isUnroll,
    changeUnroll,
    changeAllUnroll,

    setIsUpdateList,
    isUpdateList,

    onDragEnd,
  };
};
